/* VAVCI · Contacto — chips de motivo + badge "Abierto ahora".
   Sin librerías. Lee el horario desde data-* y la hora en Europe/Madrid vía Intl. */
(function () {
  'use strict';

  // ── Chips de motivo → rellenan el hidden contact[Motivo] ──
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-reason]');
    if (!chip) return;
    var group = chip.closest('.vcf__chips');
    if (!group) return;
    var chips = group.querySelectorAll('[data-reason]');
    for (var i = 0; i < chips.length; i++) {
      chips[i].classList.remove('is-active');
      chips[i].setAttribute('aria-pressed', 'false');
    }
    chip.classList.add('is-active');
    chip.setAttribute('aria-pressed', 'true');
    var hidden = document.querySelector('[data-vcf-reason]');
    if (hidden) hidden.value = chip.getAttribute('data-reason') || '';
  });

  // ── Badge horario ──
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function toMin(hhmm) {
    if (!hhmm) return null;
    var p = String(hhmm).split(':');
    if (p.length !== 2) return null;
    var h = parseInt(p[0], 10), m = parseInt(p[1], 10);
    if (isNaN(h) || isNaN(m)) return null;
    return h * 60 + m;
  }

  function nowInTz(tz) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false
    });
    var map = {};
    fmt.formatToParts(new Date()).forEach(function (p) { map[p.type] = p.value; });
    var days = { Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6, Sun: 7 };
    var dow = days[map.weekday] || 1;
    var h = parseInt(map.hour, 10);
    if (h === 24) h = 0; // en-GB puede emitir "24" a medianoche
    return { dow: dow, minutes: h * 60 + parseInt(map.minute, 10) };
  }

  function dayWord(dow) {
    return ['', 'el lunes', 'el martes', 'el miércoles', 'el jueves', 'el viernes', 'el sábado', 'el domingo'][dow] || '';
  }

  function inDayRange(r, dow) {
    // from > to = tramo que cruza el cambio de semana (p. ej. Domingo–Viernes: 7 → 5)
    if (r.from <= r.to) return dow >= r.from && dow <= r.to;
    return dow >= r.from || dow <= r.to;
  }

  function rowsForDay(rows, dow) {
    return rows.filter(function (r) { return inDayRange(r, dow) && !r.closed && r.open != null && r.close != null; });
  }

  function nextOpening(rows, now) {
    for (var add = 0; add < 8; add++) {
      var dow = ((now.dow - 1 + add) % 7) + 1;
      var todays = rowsForDay(rows, dow).sort(function (a, b) { return a.open - b.open; });
      for (var i = 0; i < todays.length; i++) {
        if (add === 0 && now.minutes >= todays[i].open) continue; // ya pasó hoy
        var h = Math.floor(todays[i].open / 60), m = todays[i].open % 60;
        var when = add === 0 ? 'hoy' : (add === 1 ? 'mañana' : dayWord(dow));
        return { when: when, time: pad(h) + ':' + pad(m) };
      }
    }
    return null;
  }

  function initHours() {
    var box = document.querySelector('[data-vcf-hours]');
    var status = document.querySelector('[data-vcf-status]');
    if (!box || !status) return;
    var textEl = status.querySelector('[data-vcf-status-text]');
    if (!textEl) return;
    var tz = box.getAttribute('data-tz') || 'Europe/Madrid';

    var rows = Array.prototype.slice.call(box.querySelectorAll('[data-dow-from]')).map(function (el) {
      return {
        from: parseInt(el.getAttribute('data-dow-from'), 10),
        to: parseInt(el.getAttribute('data-dow-to'), 10),
        open: toMin(el.getAttribute('data-open')),
        close: toMin(el.getAttribute('data-close')),
        closed: el.getAttribute('data-closed') === 'true'
      };
    }).filter(function (r) { return !isNaN(r.from) && !isNaN(r.to); });
    if (!rows.length) return;

    var now;
    try { now = nowInTz(tz); } catch (err) { return; }

    var openNow = null;
    var todays = rowsForDay(rows, now.dow);
    for (var i = 0; i < todays.length; i++) {
      if (now.minutes >= todays[i].open && now.minutes < todays[i].close) { openNow = todays[i]; break; }
    }

    status.removeAttribute('hidden');
    status.classList.remove('is-open', 'is-closed');

    if (openNow) {
      status.classList.add('is-open');
      var ch = Math.floor(openNow.close / 60), cm = openNow.close % 60;
      textEl.textContent = 'Abierto ahora · cierra a las ' + pad(ch) + ':' + pad(cm);
    } else {
      status.classList.add('is-closed');
      var next = nextOpening(rows, now);
      textEl.textContent = next ? ('Cerrado · abre ' + next.when + ' a las ' + next.time) : 'Cerrado ahora';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHours);
  } else {
    initHours();
  }
})();
